export default __webpack_public_path__ + "static/media/logo-caption-white.e113c71f.png";